import React, { FC } from "react";

import { Badge } from "@/components/Badge";
import { Text } from "@/components/Text";
import { ISkill } from "@/data/skills";

interface ISkillBadgeProps {
  skill: ISkill;
  onClick: (skillId: number) => void;
}

export const SkillBadge: FC<ISkillBadgeProps> = ({ skill, onClick }) => {
  return (
    <Badge
      backgroundColor="primary"
      color="background-card"
      borderColor="primary"
      icon="close"
      onClick={() => onClick(skill.id)}
      contentMargin={[false, "sm"]}>
      <Text>{skill.name}</Text>
    </Badge>
  );
};
